<template>
    <div class="SignResult">
        <div class="left">
            <template  v-if="isSuccess==1">
                <i :class="ticketinfo.status==9?'el-icon-error':'el-icon-success'"></i>
                <p class="payTitle" v-if="ticketinfo.status==1">感谢您的报名。请耐心等待审核，审核通过进行支付。</p>
                <p class="payTitle" v-else-if="ticketinfo.status==9">当前订单待支付，请尽快支付</p>
                <p class="payTitle" v-else-if="ticketinfo.status==10||ticketinfo.status==30">感谢您的报名。您可以在个人中心查看票券详情</p>
                <div class="left_box">
                    <p class="title">{{eventinfo.title}}</p>
                    <p>{{eventinfo.begintime}} - {{eventinfo.endtime}}</p>
                    <p class="address">{{eventinfo.address}}</p>
                    <img class="line" :src="line" alt="">
                    <div class="box_bottom">
                        <p><span>{{ticketinfo.ticketname}}</span><span><b v-if="ticketinfo.seasonticketcount!=1">{{ticketinfo.seasonticketcount}}人套票</b> ¥{{ticketinfo.uprice}} ×{{ticketinfo.ticketnum}}</span></p>
                        <p>
                            <span>状态</span>
                            <span v-bind:class="{yellow:ticketinfo.status==1,green:ticketinfo.status==10||ticketinfo.status==30,red:ticketinfo.status==9}">{{ticketinfo.status==1?'待审核':(ticketinfo.status==10||ticketinfo.status==30?'报名成功':'待支付')}}</span>
                        </p>
                    </div>
                </div>
            </template>
            <template v-else>
                <i class="el-icon-error"></i>
                <p class="payTitle">{{errorMsg}}</p>
            </template>
            <div class="com_footer">
                <el-button @click="goDet">活动详情</el-button>
                <el-button type="primary" @click="seeOrder">查看订单</el-button>
            </div>
        </div>
        <!--为您推荐-->
        <div class="rightList">
            <div class="tab_item">为您推荐</div>
            <div class="tab_main report_list">
                <div class="report_list_item" v-for="(item,index) in eventList" :key="index" @click="likeClick(item.eventid)">
                    <template v-if="index<2">
                        <span class="reportBg"><img :src="item.eventlogo" alt=""></span>
                        <span>{{item.title}}</span>
                        <span class="line"></span>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {queryOrderPayResultByEnroll,getRecommendEvent} from 'api/hdApi'
    import {mapActions} from 'vuex'
    export default {
        name: "SignResult",
        data(){
            return{
                param: {
                    result: this.$route.query.result ? this.$route.query.result : '',
                    orderno: this.$route.query.orderid ? this.$route.query.orderid : '',
                    rid: this.$route.query.rid ? this.$route.query.rid : '',
                    sign: this.$route.query.sign ? this.$route.query.sign : '',
                    ispaysuccess:this.$route.query.ispaysuccess ? this.$route.query.ispaysuccess : '',
                },
                line:require('@/common/images/hd/line.png'),
                eventList:[],  //为你推荐活动列表
                eventinfo:{},
                ticketinfo:{},
                isSuccess:0, //接口是否调用成功
                errorMsg:'', //接口报错文案
                isshow:false
            }
        },
        mounted(){
            this.getResult()
            this._getActiveList()
        },
        methods:{
            //查询支付结果
            getResult() {
                this.setLoading(true);
                queryOrderPayResultByEnroll({
                    data: this.param,
                    success: data => {
                        this.isshow=true
                        this.eventinfo=data.data.eventinfo;
                        this.ticketinfo=data.data.ticketinfo
                        this.isSuccess=1
                    },
                    error: data => {
                        this.setLoading(false);
                        this.$message.error(data.msg)
                        this.isSuccess=0
                        this.errorMsg=data.msg
                    }
                })
            },
            //跳转至活动详情
            goDet(){
                this.$router.push({name: 'HdDetails',query:{eventid:this.eventinfo.eventid}})
            },
            //获取推荐活动列表
            _getActiveList(){
                this.setLoading(true);
                let param={
                    eventid:this.$route.query.eventid?this.$route.query.eventid:'3dbXj5klLhLfSFG9'
                };
                getRecommendEvent({
                    data: Object.assign({}, param),
                    success: data => {
                        this.setLoading(false);
                        this.eventList=data.data
                    },
                    error: data => {
                        this.setLoading(false);
                        this.$message.error(data.msg)
                    }
                })
            },
            //查看订单
            seeOrder(){
                this.$router.push({name: 'MyOrder',query:{kmctype:13}})
            },
            ...mapActions([
                'setLoading',
            ])
        }
    }
</script>

<style lang="scss">
    .SignResult{
        width: 1200px;
        margin: 30px auto;
        display: flex;
        justify-content: space-between;
        .left{
            margin: 0 auto;
            text-align: center;
            i{
                font-size: 56px;
            }
            .el-icon-success{
                color: #0ABF53;
            }
            .el-icon-error{
                color: #FF4747;
            }
            .payTitle{
                margin: 20px 0;
                font-size: 16px;
            }
            .left_box{
                width:300px;
                max-width: 300px;
                height:auto;
                background:rgba(255,255,255,1);
                box-shadow:0px 2px 6px 0px rgba(0,0,0,0.1);
                padding: 20px;
                font-size: 12px;
                color: #666666;
                text-align: left;
                p{
                    line-height: 20px;
                }
                .title{
                    font-size: 14px;
                    color: #333;
                    margin-bottom: 12px;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                }
                .address{
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                }
                .line{
                    margin-left: -25px;
                }
                .box_bottom{
                    font-size: 14px;
                    p{
                        display: flex;
                        justify-content: space-between;
                        font-size: 14px;
                        color: #333;
                        .yellow{
                            color: #FFA904;
                        }
                        .green{
                            color: #0ABF53;
                        }
                        .red{
                            color: #FF4747;
                        }
                    }
                    p:first-child{
                        margin-bottom: 10px;
                        b{
                            font-size: 12px;
                            color: #999;
                            margin-right: 6px;
                        }
                    }
                }
            }
            .com_footer{
                margin-top: 30px;
                .el-button{
                    width: 160px;
                    height: 40px;
                    border: 1px solid #1464C8;
                    color: #1464C8;
                }
                .el-button:focus, .el-button:hover{
                    opacity: 0.8;
                }
                .el-button--primary{
                    background-color: #1464C8;
                    color: #fff;
                }
                .el-button+.el-button{
                    margin-left: 20px;
                }
            }
        }
        .rightList{
            width: 285px;
            .tab_item{
                font-size: 16px;
                color: #333;
                margin-bottom: 20px;
            }
            .tab_main{
                box-shadow:0px 0px 8px 0px rgba(0,0,0,0.1);
                border-radius:6px;
                padding: 20px 0;
                margin-bottom: 20px;
                .noData_wrap{
                    text-align: center;
                    width: 100%;
                    font-size: 12px;
                    color: #999;
                    padding: 20px 0;
                    img{
                        margin: 0 auto 12px;
                    }
                }
            }
            .report_list{
                border-top: none;
                .report_list_item:nth-child(2) .line{
                    display: none;
                }
                .report_list_item{
                    padding: 0 20px;
                    cursor: pointer;
                    .reportBg{
                        margin-bottom: 12px;
                        img{
                            width:260px;
                            height:147px;
                        }
                    }
                    span{
                        line-height: 22px;
                        display: inline-block;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 3;
                        overflow: hidden;
                    }
                    .line{
                        width: 100%;
                        height: 1px;
                        background: #E5E5E5;
                        margin: 20px 0;
                    }
                }
                .sponsor{
                    .reportBg{
                        display: flex;
                        align-items: center;
                        border-bottom: 1px solid #e5e5e5;
                        padding-bottom: 20px;
                        img{
                            width:72px;
                            height:72px;
                            border-radius: 50%;
                            margin-right: 10px;
                        }
                    }
                    span:last-child{
                        color: #999;
                    }
                }
            }
        }
    }
</style>